import React, { Component } from 'react';
import PhoneInput2 from 'react-phone-input-2';
import { connect } from 'react-redux';
import { Col, FormGroup, Label } from 'reactstrap';
import { onSendFaxFilesChange, onSendFaxNumberChange } from '../actions/Fax';
import CustomDropzone from './CustomDropzone';

class SendFaxForm extends Component {
  constructor(props) {
    super(props);
    this.onNumberChange = this.onNumberChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
  }

  onNumberChange(faxNumber) {
    this.props.onNumberChange(faxNumber);
  }

  onFileChange(files) {
    console.log('File Changed!', files);
    this.props.onFileChange(files);
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <Col sm={12}>
            <FormGroup row>
              <Label for="number" sm={4}>
                Number:
              </Label>
              <Col sm={12} md={9}>
                <PhoneInput2
                  inputExtraProps={{ name: 'number' }}
                  value={this.props.number}
                  onChange={this.onNumberChange}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="faxFile" sm={8}>
                Upload Fax:
              </Label>
              <Col sm={12} md={12}>
                <CustomDropzone
                  onFileChange={this.onFileChange}
                  files={this.props.files}
                />
              </Col>
            </FormGroup>
          </Col>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  number: state.UIState.faxes.sendFax.number,
  files: state.UIState.faxes.sendFax.files,
});

const mapDispatchToProps = dispatch => ({
  onNumberChange: number => dispatch(onSendFaxNumberChange(number)),
  onFileChange: files => dispatch(onSendFaxFilesChange(files)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SendFaxForm);
